import React, { useState, useRef, forwardRef, useEffect } from "react";
import { Row, Col, Container, Button, Form } from "react-bootstrap";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useLocation } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import Toaster, { showSuccess, showError, showWarning } from "../utility/ui/notifications/Toaster";
import GridMaster from "../utility/grid/GridMaster";
import { Action, Status } from "./WCSObjects/WCS_entity";
import AddEditWCS from "./AddEditWCS";
import { getAllProject } from "../../Services/project-services";
import ActionRenderer_inlinEdit from "../utility/grid/renderers/ActionRenderers/ActionRenderer_inlinEdit";
import { checkWPSinArray } from "../WPSTransaction/WPSObjects/WPS_Validations";
import { UpdateDetailWCS, getbyprojectno, DeleteWCSDetail, getGridDetailData } from "../../Services/wcs-services";
import WCSFormStatus from "./WCSObjects/WCSFormStatus";
import viewNote from "../../icons/viewNote.svg";
import uploadImage from "../../icons/uploadImage.svg";
import { isAlphanumericWithDash } from "../../functions/validations";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import WCSViewNote from "./WCSViewNote";
import { checkJointNoPresent } from "../../Services/WI-services";
import { errorstyle, normalstyle } from "../../functions/welding-functions";
import { ICONS } from "../utility/common/constants/icons";

/**
 * WCS (Welding Change Sheet) Detail Component
 * 
 * PURPOSE:
 * Manages welding procedure specification (WPS) changes for specific projects.
 * Tracks change history, validates WPS numbers, and manages approval workflow.
 * 
 * KEY FEATURES:
 * 1. Change Number Management - Auto-increments change numbers for tracking
 * 2. Status Workflow - Pending → Approved/Rejected workflow
 * 3. WPS Validation - Ensures WPS numbers exist and are not duplicated
 * 4. Role-based Access - Different permissions for initiators vs approvers
 * 5. Change Detail Tracking - Each row gets unique change detail number
 * 
 * CHANGE NUMBER LOGIC:
 * - WCS_Change_No: Master change number for the entire WCS (increments on each submission)
 * - WCS_ChangeDetail_No: Individual change detail number for each grid row (starts at 1)
 * - Change numbers are used for audit trail and version control
 * 
 * STATUS WORKFLOW:
 * - Pending: Initial state when changes are submitted
 * - Approved: Approved by P/T band users (approvers)
 * - Rejected: Rejected by P/T band users (approvers)
 * 
 * ROLE PERMISSIONS:
 * - Initiators (Non P/T band): Can create and modify pending changes
 * - Approvers (P/T band): Can approve/reject changes, cannot modify
 */
const WCSDetail = forwardRef((props, ref) => {
  const location = useLocation();
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [gridApi, setGridApi] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [setExcelData] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  
  // User role and permissions
  let Band = sessionStorage.getItem("Band");
  let approver = Band == "P" || Band == "T";  // P/T band users can approve/reject
  let initiator = Band !== "P" && Band !== "T"; // Non P/T band users can initiate changes
  let userName = sessionStorage.getItem("UserName");
  let userEmailId = sessionStorage.getItem("User");
  
  // WCS Status and Change Management
  const [WCSStatus, setWCSStatus] = useState("");     // Current status (Pending/Approved/Rejected)
  const [preStatus, setPreStatus] = useState("");     // Previous status for comparison
  const [WCSChangeNo, setWCSChangeNo] = useState(0);   // Master change number (auto-incremented)
  
  const [WPSNoList] = useState("");
  const [ProjectDetails, setProjectDetails] = useState([]);
  const [showViewNote, setshowViewNote] = useState(false);
  let myResult; // WPS validation result

  const [error, setError] = useState({
    WCS_Project_No: {},
  });

  const childRef = useRef();
  const [headerObj, setheaderObj] = useState([]);
  const [WCSProjectNo, seWCSProjectNo] = useState(location.state?.data);

  const tmpcolumnDefs = [
    {
      headerName: "Project Number",
      field: "WCS_Project_No",
      cellRenderer: "",
      Error: true,
    },
    {
      headerName: "Joint Number",
      field: "WCS_Joint_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      Error: true,
    },
    {
      headerName: "WPS Number 1",
      field: "WCS_WPS_No1",
      type: "WPSearch",
      isCheckbox: false,
      editable: true,
      Error: true,
      cellStyle: { borderRadius: "4px", lineheight: "2.5px" },
      cellClass: "hover-border"
    },
    {
      headerName: "WPS Number 2",
      field: "WCS_WPS_No2",
      isCheckbox: false,
      cellRenderer: "",
      editable: true,
      type: "WPSearch",
      Error: true,
      cellStyle: { borderRadius: "4px", lineheight: "2.5px" },
      cellClass: "hover-border"
    },
    {
      headerName: "WPS Number 3",
      field: "WCS_WPS_No3",
      isCheckbox: false,
      editable: true,
      type: "WPSearch",
      Error: true,
      cellStyle: { borderRadius: "4px", lineheight: "2.5px" },
      cellClass: "hover-border"
    },
    {
      headerName: "WPS Number 4",
      field: "WCS_WPS_No4",
      isCheckbox: false,
      cellRenderer: "",
      type: "WPSearch",
      editable: true,
      Error: true,
      cellStyle: { borderRadius: "4px", lineheight: "2.5px" },
      cellClass: "hover-border"
    },
    {
      headerName: "Change ID No",
      field: "WCS_ChangeDetail_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      Error: true,
    },
    {
      headerName: "Updated by",
      field: "WCS_UpdatedBy_Name",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "AvatarCellRenderer",
      Error: true,
    },
    {
      headerName: "Updated On",
      field: "WCS_UpdatedOn",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
      Error: true,
    },
  ];

  const actionRenderer = (params) => {
    setGridApi(params);
    return (
      <ActionRenderer_inlinEdit
        selectedData={params}
        gridPage="WCS"
        handleEditEvent={(params) => handleEdit(params)}
        handleDeleteEvent={(params) => handleDeleteEvent(params.data)}
      />
    );
  };

  const handleEdit = (params) => {
    params.api.startEditingCell({
      rowIndex: params.node.rowIndex,
      colKey: params.columnApi.getDisplayedCenterColumns()[3].colId,
    });
  };

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  /**
   * Fetches WCS header information and initializes change tracking
   * 
   * CHANGE NUMBER INITIALIZATION:
   * - Retrieves current WCS_Change_No from database
   * - Converts to integer for increment operations
   * - Defaults to 0 if no previous change number exists
   * - This number increments each time changes are submitted
   * 
   * STATUS TRACKING:
   * - Sets current status (WCSStatus) for UI display
   * - Stores previous status (preStatus) for comparison
   * - Used to determine if status change occurred
   */
  const fetchWCSHeader = async () => {
    let result = await getbyprojectno(WCSProjectNo);
    setheaderObj(result);
    if (result !== undefined && result[0] !== undefined) {
      // Set current and previous status for tracking changes
      setWCSStatus(result[0].WCS_Status);
      setPreStatus(result[0].WCS_Status);
      
      // Initialize change number (auto-increment counter)
      setWCSChangeNo(
        result[0].WCS_Change_No !== "" || result[0].WCS_Change_No !== undefined
          ? parseInt(result[0].WCS_Change_No)
          : 0
      );
    }
  };

  /**
   * Fetches WCS detail grid data and initializes change tracking properties
   * 
   * CHANGE DETAIL NUMBER LOGIC:
   * - Each grid row gets a unique WCS_ChangeDetail_No starting from 1
   * - This number identifies individual changes within a change set
   * - Used for granular tracking of which specific WPS changes were made
   * - Helps in audit trail and change history reporting
   * 
   * CHANGE TRACKING PROPERTIES:
   * - isModified: Tracks if row has been edited (triggers validation)
   * - hasError: Indicates validation errors for the row
   * - ErrorMessage: Stores validation error details
   */
  const fetchWCSDetail = async () => {
    let result = await getGridDetailData(
      WCSProjectNo,
      sessionStorage.getItem("User")
    );

    if (result !== undefined && result !== "undefined" && result.length > 0) {
      for (const item of result) {
        // Initialize change tracking properties
        item.isModified = false;     // Track if row was edited
        item.hasError = false;       // Track validation errors
        item.ErrorMessage = "";      // Store error messages
        
        // Initialize change detail number (unique per row)
        item.WCS_ChangeDetail_No =
          item.WCS_ChangeDetail_No === undefined
            ? 1  // Start from 1 for new changes
            : parseInt(item.WCS_ChangeDetail_No);
      }
    }
    setFilteredResult(result);
  };

  const fetchColumnDefns = async () => {
    const result1 = GlobalColumnDefinations(tmpcolumnDefs);
    let result = [];
    result.push({
      headerName: "",
      cellRenderer: actionRenderer,
      width: 0,
      Error: true,
      sortable: false,
      suppressMenu: true,
    });
    result1.forEach((e) => {
      result.push(e);
    });
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchWCSHeader();
    fetchWCSDetail();
    fetchColumnDefns();
    fetchProject();
  }, [reload]);

  const handleGlobalSearch = (text) => {
    let searchText = text.toLowerCase();
    childRef.current.setSearch(searchText);
  };

  const handleSubmit = (e) => {
    fetchWCSHeader();
    fetchWCSDetail();
  };

  const handleGlobalExport = () => {
    let filename = "WCSDetail";
    handleExport1(filteredResult, filename, tmpcolumnDefs);
  };

  /**
   * Main submission handler for WCS changes
   * 
   * WORKFLOW:
   * 1. Status Update: Sets new status (Pending/Approved/Rejected)
   * 2. Validation: Validates modified rows for WPS requirements
   * 3. WPS Existence Check: Verifies all WPS numbers exist in system
   * 4. Change Number Increment: Updates master change number
   * 5. Database Update: Saves changes with new change numbers
   * 
   * VALIDATION RULES:
   * - WPS No 1 is mandatory for all joints
   * - No duplicate WPS numbers within same joint
   * - All WPS numbers must exist in the system
   * 
   * CHANGE TRACKING:
   * - Only processes rows marked as isModified = true
   * - Increments WCS_Change_No for audit trail
   * - Maintains WCS_ChangeDetail_No for individual changes
   * 
   * @param {string} buttonClick - New status (Pending/Approved/Rejected)
   */
  const handlesubmition = async (buttonClick) => {
    setWCSStatus(buttonClick);
    try {
      let hasValidationErrors = false;
      
      // Get only modified rows for processing
      let updateditems = filteredResult.filter((e) => e.isModified === true);
      
      // VALIDATION PHASE: Check WPS number requirements and duplicates
      filteredResult.filter((e) => e.isModified === true)
        .map((item) => {
          let WCS_WPS_No1 = item.WCS_WPS_No1;
          let WCS_WPS_No2 = item.WCS_WPS_No2;
          let WCS_WPS_No3 = item.WCS_WPS_No3;
          let WCS_WPS_No4 = item.WCS_WPS_No4;

          // Reset error state
          item.ErrorMessage = "";
          item.hasError = false;
          
          // RULE 1: WPS No 1 is mandatory
          if (WCS_WPS_No1 === undefined || String(WCS_WPS_No1).trim() === "") {
            hasValidationErrors = true;
            item.hasError = true;
            item.ErrorMessage += "WPS No 1 is mandatory for Joint No., ";
          }

          // RULE 2: No duplicate WPS numbers within same joint
          if (
            WCS_WPS_No2 !== undefined &&
            String(WCS_WPS_No2).trim() !== "" &&
            WCS_WPS_No2 === WCS_WPS_No1
          ) {
            hasValidationErrors = true;
            item.hasError = true;
            item.ErrorMessage += "WPS No 2 is duplicate for Joint No., ";
          }

          if (
            WCS_WPS_No3 !== undefined &&
            String(WCS_WPS_No3).trim() !== "" &&
            (WCS_WPS_No3 === WCS_WPS_No1 || WCS_WPS_No3 === WCS_WPS_No2)
          ) {
            hasValidationErrors = true;
            item.hasError = true;
            item.ErrorMessage += " WPS No 3 is duplicate for Joint No., ";
          }

          if (
            WCS_WPS_No4 !== undefined &&
            String(WCS_WPS_No4).trim() !== "" &&
            (WCS_WPS_No4 === WCS_WPS_No1 ||
              WCS_WPS_No4 === WCS_WPS_No2 ||
              WCS_WPS_No4 === WCS_WPS_No3)
          ) {
            hasValidationErrors = true;
            item.hasError = true;
            item.ErrorMessage += "WPS No 4 is duplicate for Joint No., ";
          }
        });


      let wpsnos = getArrayList(updateditems);

      if (updateditems.length > 0) {
        let finaled = {
          project: updateditems[0].WCS_Project_No,
          WPSNo_Array: wpsnos,
        };

        myResult = await checkWPSinArray(finaled);

        let notfounds = [];
        if (myResult) {
          notfounds = wpsnos.filter((x) => !myResult.includes(x.wps));
          notfounds.forEach((element) => {
            let WCSError = updateditems.filter(
              (e) =>
                String(e.WCS_WPS_No1) == element.wps ||
                String(e.WCS_WPS_No2) == element.wps ||
                String(e.WCS_WPS_No3) == element.wps ||
                String(e.WCS_WPS_No4) == element.wps
            );



            WCSError.forEach((element1) => {
              hasValidationErrors = true;

              element1.hasError = true;
              element1.ErrorMessage += "WPS invalid";
            });
          });
        }
      }



      if (buttonClick === "Approved") {
        setAction(Action.ActionApprove);
      } else if (buttonClick === "Rejected") {
        setAction(Action.ActionReject);
      } else if (
        updateditems &&
        updateditems.length > 0 &&
        buttonClick === "Pending For Approval"
      ) {
        setAction(Action.ActionEdit);
      } else if (updateditems.length === 0 && "Pending For Approval") {
        setAction(Action.ActionSend);
      }

      if (hasValidationErrors) {

        gridApi.api.applyTransaction({ update: updateditems });
      } else {
        gridApi.api.applyTransaction({ update: updateditems });
        setShowConfirmModal(true);
      }
    } catch (error) {
      console.error("Failed to update data:", error, filteredResult);
      showError("Failed to update data");
    }
  };

  function getArrayList(start) {
    let arr_list = [];
    start.forEach((element, index) => {


      arr_list.push({ wps: element.WCS_WPS_No1 });
      if (element.WCS_WPS_No2 !== "" && element.WCS_WPS_No2 !== undefined)
        arr_list.push({ wps: element.WCS_WPS_No2 });
      if (element.WCS_WPS_No3 !== "" && element.WCS_WPS_No3 !== undefined)
        arr_list.push({ wps: element.WCS_WPS_No3 });
      if (element.WCS_WPS_No4 !== "" && element.WCS_WPS_No4 !== undefined)
        arr_list.push({ wps: element.WCS_WPS_No4 });
    });

    return arr_list;
  }

  const handleConfirmAction = async () => {
    try {
      let WCSHeader = {
        WCS_Status: "",
        WCS_ApprovedBy_Name: "",
        WCS_ApprovedBy: "",
        SK: WCSProjectNo,
        WCS_UpdatedBy_Name: "",
        WCS_UpdatedBy: "",
        WCS_Change_No: 0,
      };

      let upDater = {};
      upDater.WCS_UpdatedBy_Name = userName;
      upDater.WCS_UpdatedBy = userEmailId;
      let updateditems = filteredResult.filter((e) => e.isModified === true);

      if (approver) {
        WCSHeader.WCS_Status = WCSStatus;

        WCSHeader.WCS_Change_No =
          updateditems.length > 0 ? WCSChangeNo + 1 : WCSChangeNo;
        WCSHeader.WCS_ApprovedBy_Name = userName;
        WCSHeader.WCS_ApprovedBy = userEmailId;
      } else if (initiator) {



        WCSHeader.WCS_Status = Status.StatusPending;
        WCSHeader.WCS_Change_No =
          updateditems.length > 0 ? WCSChangeNo + 1 : WCSChangeNo;


        WCSHeader.WCS_UpdatedBy_Name = userName;
        WCSHeader.WCS_UpdatedBy = userEmailId;
      }

      let upDateRequest = { updateditems, upDater, headerObj: WCSHeader };

      if (preStatus == Status.StatusApproved) {
        updateditems.map((i) => {
          i.WCS_ChangeDetail_No = parseInt(i.WCS_ChangeDetail_No) + 1;
        });
      }
      if (updateditems.length > 0) {
        setWCSChangeNo(WCSChangeNo + 1);
      }


      await UpdateDetailWCS(upDateRequest);


      showSuccess("Data updated successfully");
    } catch (error) {
      console.error("Failed to update data:", error);
      showError("Failed to update data");
    }
    setShowConfirmModal(false);

  };

  const handleCancelAction = () => {
    setShowConfirmModal(false);
  };


  const resetForm = () => {
    document.filterForm.reset();
    setFilteredResult(null);
  };

  const fetchProject = async () => {
    //Review use GetAllProjects
    let result = await getAllProject();
    if (result?.length > 0)
      result = result.filter((item) => item.wld_status == "Active");
    setProjectDetails(result);
  };

  const gridOptions = {
    singleClickEdit: true
  };

  const hanldeExcelFileUpload = (e) => {
    setAction(Action.ActionUpload);
    setShowForm(true);
  };

  const hanldeViewNote = (e) => {
    setshowViewNote(true);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    setAction(Action.ActionAdd);
    setShowForm(true);
  };

  let isPresent;
  const handleDeleteEvent = async (row) => {
    try {
      setAction("Delete");
      isPresent = await checkJointNoPresent(row);

      if (isPresent) {
        showWarning("WCS already in use, cannot be deleted");
      } else {
        setRowData(row);
        let gridDetail = { PK: row.PK, SK: row.SK };
        await DeleteWCSDetail(gridDetail);
        showSuccess(`Selected DetailGrid is Deleted`);

      }
      setReload(true);
    } catch (error) {
      console.error("Cancellation failed:", error);
    }
  };

  return (
    <>
      <div className="title1">
        WCS<button type="button" className="add-btn wcs-add-btn" onClick={(e) => handleAdd(e)}>
          <div className="text">
            <img src="../sidebar/add.png"></img>
            Add WCS
          </div>
        </button>
      </div>
      <Container fluid>
        <ConfirmAlertModal
          handleYes={handleConfirmAction}
          handleNo={handleCancelAction}
          action={action}
          show={showConfirmModal}
          handleClose={() => setShowConfirmModal(false)}
          formName={"WCS Details"}
        />
        <Row xs="auto" className="align-items-center">
          <Col style={{ width: "20%" }}>
            <Form.Group className="pro-input-select">
              <div className="search-select">
                <SearchSelect
                  id="WCS_Project_No"
                  name="WCS_Project_No"
                  className={error.WCS_Project_No.status ? "err-input" : ""}
                  stylegreen={
                    error.WCS_Project_No.status ? errorstyle : normalstyle
                  }
                  data={ProjectDetails}
                  valueField={"wld_ProjectNumber"}
                  value={WCSProjectNo}
                  labelField={"wld_ProjectNumber"}
                  placeholder=""
                  onChange={(ProjectList) => {

                    setheaderObj((prev) => ({
                      ...prev,
                      WCS_Project_No: ProjectList.value,
                    }));
                    setError((prevState) => ({
                      ...prevState,
                      WCS_Project_No: {},
                    }));
                    seWCSProjectNo(ProjectList.value);
                  }}
                  onInput={(e) => {
                    let error = isAlphanumericWithDash(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      WCS_Project_No: error,
                    }));
                  }}
                ></SearchSelect>
              </div>
            </Form.Group>
          </Col >
          <Col style={{ position: "relative", right: "12px" }}>
            <Button className="showresult" onClick={handleSubmit} style={{ height: "37px", width: "104px" }}>
              <p style={{ position: "relative", top: "8px", fontSize: "14px" }}>Show Result</p>
            </Button>
          </Col>
          <Col ColSize="auto" style={{ position: "relative", left: "5px" }}>
            <Form.Group>
              <div className="gno-input w-100 mb-0">
                <input
                  type="text"
                  id="WCS_Change_No"
                  name="WCS_Change_No"
                  readOnly
                  placeholder=" "
                  disabled={action == Action.ActionEdit}
                  maxLength={20}
                  value={WCSChangeNo}
                />
                <Form.Label htmlFor="WCS_Change_No">WCS Change No.</Form.Label>
              </div>
            </Form.Group>
          </Col>
          <Col style={{ position: "relative", right: "10px" }}>
            <Button
              variant="outline-success"
              className="uploadexcelbtn"
              onClick={hanldeExcelFileUpload}
              style={{ height: "34px" }}
            >
              <img src={uploadImage}></img>
              &nbsp;
              <b>Upload Excel</b>
            </Button>
          </Col>
          <Col style={{ position: "relative", right: "23px" }}>
            <Form.Label className="viewNoteLbl" onClick={hanldeViewNote}>
              <img src={viewNote}></img>
              &nbsp;
              <b>View Note</b>
            </Form.Label>
          </Col>
        </Row>
        <Row
          className="RowHeight align-items-center"
          style={{ position: "relative", marginTop: "5px" }}
        >
          <Col xs={1}>
            <WCSFormStatus formStatus={WCSStatus} />
          </Col>
          <Col>
            <div className="global-search-container">
              <GolbalSearch
                searchplaceholdertext={
                  "Search for Project No.,Joint no.,WPS No 1,2,3 and 4"
                }
                filterFunc={handleGlobalSearch}
              />
              <img
                className="allexport"
                src={ICONS.Export}
                alt="ExportIcon"
                onMouseOver={(e) => (e.currentTarget.src = ICONS.ExportBlue)}
                onMouseOut={(e) => (e.currentTarget.src = ICONS.Export)}
                onClick={handleGlobalExport}
              />
            </div>
          </Col>
        </Row>
        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          defaultColDef={{ resizable: true }}
          fieldNames={fieldName}
          headerNames={headerName}

          setExcelData={setExcelData}
          ref={childRef}
          gridOptions={gridOptions}
          paginationPageSize={4}

          height={340}
        />

        <Toaster />
        {showForm && (
          <AddEditWCS
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            resetForm={resetForm}
            setReload={setReload}
            reload={reload}
            headerObj={headerObj}
            setheaderObj={setheaderObj}

            backdrop="static"
            selectProject={WCSProjectNo}
            WPSNoList={WPSNoList}
          />
        )}
        {showViewNote && (
          <WCSViewNote
            show={showViewNote}
            onHide={() => setshowViewNote(false)}
            backdrop="static"
          />
        )}
      </Container>
      <Row className="RowHeightWCS">
        <Col>
          <div>
            {approver ? (
              <>
                <Button
                  onClick={() => handlesubmition(Status.StatusRejected)}
                  className="wcsreject"
                  style={{
                    width: "109px",
                    height: "40px",
                    paddingTop: "5px"
                  }}
                >
                  Reject
                </Button>
                <Button
                  onClick={() => handlesubmition(Status.StatusApproved)}
                  className="wcsapprove"
                  style={{
                    width: "109px",
                    height: "40px",
                    paddingTop: "5px"
                  }}
                >
                  Approve
                </Button>
              </>
            ) : (
              <>
                <Col style={{ position: "absolute", right: "25px", bottom: "30px" }}>
                  <Button
                    onClick={(event) => handlesubmition(Status.StatusPending)}
                    className="sendapprovald btn-primary"
                  >
                    Send For Approval
                  </Button>
                </Col>
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
});

export default WCSDetail;
